export const CHROME_PRESETS = {
    light: {
        appBarBg:         '#FFFFFF',
        appBarBorder:     '#E5E7EB',
        appBarText:       '#111827',
        appBarTextMuted:  '#6B7280',

        sidebarBg:        '#FAFAFA',
        sidebarBorder:    '#E5E7EB',
        sidebarText:      '#6B7280',
        sidebarTextHover: '#111827',
        sidebarTextActive:'#111827',
        sidebarItemHover: '#F3F4F6',
        sidebarItemActive:'#EEF2FF',
        sidebarIcon:      '#9CA3AF',
        sidebarIconActive:'#111827',
        sidebarHeading:   '#9CA3AF',
        sidebarDivider:   '#E5E7EB',
    },
    dark: {
        appBarBg:         '#FFFFFF',
        appBarBorder:     '#E5E7EB',
        appBarText:       '#111827',
        appBarTextMuted:  '#6B7280',

        sidebarBg:        '#1F2937',
        sidebarBorder:    '#111827',
        sidebarText:      '#CBD5E1',
        sidebarTextHover: '#FFFFFF',
        sidebarTextActive:'#FFFFFF',
        sidebarItemHover: 'rgba(255,255,255,0.05)',
        sidebarItemActive:'rgba(255,255,255,0.08)',
        sidebarIcon:      '#CBD5E1',
        sidebarIconActive:'#FFFFFF',
        sidebarHeading:   '#64748B',
        sidebarDivider:   'rgba(255,255,255,0.08)',
    },
};

export const CHROME = CHROME_PRESETS.dark;
